export default "__VITE_ASSET__CEQAUtGf__"